import { inr, inrShort } from "@/lib/api";

const STEPS = [
  ["target", "Target", "#474747"], ["pipeline", "Pipeline", "#275248"], ["forecast", "Forecast", "#4f9a6a"],
  ["won", "Won revenue", "#73c281"], ["gap", "Gap", "#e11d48"],
];

export const RevenueFunnel = ({ data, testid = "revenue-funnel" }) => {
  const max = Math.max(...STEPS.map(([k]) => data?.[k] || 0), 1);
  return (
    <div className="grid gap-3 p-4 sm:grid-cols-5" data-testid={testid}>
      {STEPS.map(([k, label, color], i) => (
        <div key={k} className="relative">
          <p className="text-[11px] font-bold uppercase tracking-wider text-muted-foreground">{i > 0 && <span className="mr-1 text-slate-300">→</span>}{label}</p>
          <p className="num mt-1 text-xl font-semibold" style={{ color }} title={inr(data?.[k])} data-testid={`funnel-${k}`}>{inrShort(data?.[k])}</p>
          <div className="mt-2 h-2 rounded-full bg-slate-100">
            <div className="h-2 rounded-full transition-all duration-700" style={{ width: `${Math.max(2, ((data?.[k] || 0) / max) * 100)}%`, background: color }} />
          </div>
        </div>
      ))}
    </div>
  );
};
